import { render } from "./MCommentPanel.vue?vue&type=template&id=04d486b9"
const script = {}
script.render = render

export default script